import type { AxleAiModel } from "@platform/automatic-api";

// Keyed by the models automatic allows, so a model added there without a label
// here fails the type check.
const MODEL_LABELS: Record<AxleAiModel, string> = {
  "claude-opus-5-5": "Opus 5.5",
  "claude-sonnet-5-5": "Sonnet 5.5",
  "claude-haiku-5-5": "Haiku 5.5",
};

// Matches automatic's AXLE_AI_DEFAULT_MODEL.
export const DEFAULT_AXLE_AI_MODEL: AxleAiModel = "claude-sonnet-5-5";

/** The models to offer, in the order the dropdown lists them. */
export const AXLE_AI_MODEL_OPTIONS = Object.entries(MODEL_LABELS).map(
  ([id, label]) => ({ id: id as AxleAiModel, label })
);

const isModel = (value: unknown): value is AxleAiModel =>
  typeof value === "string" && value in MODEL_LABELS;

const MODEL_KEY = "axleAi.model";

/** The model the user picked last, for new chats; a per-browser preference. */
export const rememberedModel = (): AxleAiModel => {
  try {
    const model = localStorage.getItem(MODEL_KEY);
    return isModel(model) ? model : DEFAULT_AXLE_AI_MODEL;
  } catch {
    return DEFAULT_AXLE_AI_MODEL;
  }
};

export const rememberModel = (model: AxleAiModel) => {
  try {
    localStorage.setItem(MODEL_KEY, model);
  } catch (error) {
    console.warn("Could not remember the Axle AI model", error);
  }
};

/** A saved chat's model, if it's still offered; otherwise the remembered one. */
export const chatModel = (model?: string): AxleAiModel =>
  isModel(model) ? model : rememberedModel();
